export default class ClearSelectedSuggestedReply {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.selectedSuggestedReply.set(null);
  }
}
